import { useQuery, UseQueryOptions } from "react-query";
import { AxiosError } from "axios";
import { ErrorCode } from "shared-types";
import { billingService, FETCH_SUBSCRIPTIONS } from "../services";
import { ISubscription } from "../types";

export const useGetSubscriptions = (
  options?: UseQueryOptions<ISubscription[], AxiosError>
) => {
  const { data, isLoading } = useQuery<ISubscription[], AxiosError>(
    FETCH_SUBSCRIPTIONS,
    async () => {
      return await billingService.getSubscriptions();
    },
    {
      retry: (_, error) =>
        error.response?.status !== ErrorCode.MissingCountryCode,
      ...options,
    }
  );

  return { data: data || [], isLoading };
};
